import { PropsWithChildren } from 'react';

export const CalculatorLayout = ({ children }: PropsWithChildren) => (
    <div className="vss-calculator-layout">
        {children}
    </div>
);
